import Promotional from '@reusable-modules/Promotional'

const CarouselComponent = (props) => <Promotional {...props} />

export default CarouselComponent